export const BRIEFS_I18N_ROOT = "circle_ai_briefs";
export const BRIEFS_PATH = "/ai/briefs" as const;
export const BRIEFS_PER_PAGE = 20;
